interface AtAGlanceItem {
  title: string;
  description: string;
}

/**
 * Three at-a-glance facts. No icons, no tiles, no background — a 2px green
 * rule on the left of each column is the only decoration.
 */
const AtAGlance = ({ items }: { items: AtAGlanceItem[] }) => (
  <div className="grid gap-6 sm:grid-cols-3">
    {items.map((item) => (
      <div key={item.title} className="border-l-2 border-primary pl-4">
        <p className="font-heading text-[18px] font-bold leading-snug text-foreground">{item.title}</p>
        <p className="mt-1 font-body text-[15px] leading-[1.6] text-muted-foreground">{item.description}</p>
      </div>
    ))}
  </div>
);

export default AtAGlance;
